import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';
import * as Yup from 'yup';
const {
  formField: { loanLender, onSystemProperty },
} = loanFormModel;

export class LoanLenderValidation implements ValidationSchema {
  public name = loanLender.name;
  public label = loanLender.label;
  public dependsOn: string[] = [onSystemProperty.name];
  public type = 'string';
  public required = {
    message: loanLender.requiredErrorMsg,
    value: loanLender.required,
  };
  public nullable = true;
  public max = {
    message: `${loanLender.label} must be less than ${loanLender.maxLength} characters`,
    value: loanLender.maxLength,
  };

  public when(
    onSystemProperty: string,
    schema: Yup.StringSchema,
    context: any
  ) {
    if (onSystemProperty !== 'Yes') {
      return schema.required(loanLender.requiredErrorMsg);
    }
    return schema;
  }
}
export default new Validation(new LoanLenderValidation());
